import { useHistory } from "react-router";

import { ROUTES } from "@config/work.routing";

import { isLocalStorageAvailable } from "@services/IsLocalStorageAvailable";

import { LOCAL_STORAGE_KEY } from "@work/redux/booking/booking.typings";

export const LocalStoragePurger = (): null => {
  const history = useHistory();
  if (
    history.location.pathname !== ROUTES.BOOKING_SELECT_PLAN &&
    history.location.pathname !== ROUTES.BOOKING_THANK_YOU &&
    history.location.pathname !== ROUTES.PAYMENT_PROCESSED
  ) {
    if (isLocalStorageAvailable()) {
      localStorage.removeItem(LOCAL_STORAGE_KEY);
    }

    return null;
  }

  return null;
};
